import { FC } from 'react'

import SearchIcon from '@mui/icons-material/Search'
import { ReactComponent as ClockImage } from 'assets/icons/icon-clock-yellow.svg'
import { Col, Input, Row, Span } from 'components'
// import Deadline from "components/Deadline/Deadline"
import moment from 'moment'
import { CollpaseContrato } from 'services/Supplier/ThirdPartyAdministration'
import { COLORS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'

import { TextClockImage } from './styles'
interface ISearchMonthlyDocumentation {
  control: any
  dayExpiration: string
  listContracts: CollpaseContrato[]
  competenciaAtual: string
}
export const SearchMonthlyDocumentation: FC<ISearchMonthlyDocumentation> = ({
  control,
  competenciaAtual,
  dayExpiration,
  listContracts
}) => {
  const takeRemainingNumberOfDaysToExpiration = (dayExpiration: string) => {
    const now = new Date().getDate()
    const daysRemaining = parseInt(dayExpiration) - now

    if (daysRemaining < 0) {
      return 0
    }

    return daysRemaining
  }

  const getClockColor = () => {
    return takeRemainingNumberOfDaysToExpiration(dayExpiration) > 0
      ? COLORS.black
      : COLORS.error
  }

  return (
    <Row alignItems="center" justifyContent="space-between">
      {/* <Deadline /> */}
      <Row>
        {listContracts?.length > 0 && (
          <>
            <Col justifyContent="center" alignItems="center">
              <ClockImage fill={getClockColor()} />
              <TextClockImage color={getClockColor()}>
                Faltam{' '}
                <strong>
                  {takeRemainingNumberOfDaysToExpiration(dayExpiration)}
                </strong>{' '}
                {takeRemainingNumberOfDaysToExpiration(dayExpiration) === 1
                  ? 'dia'
                  : 'dias'}
              </TextClockImage>
            </Col>
            <Col alignItems="center" justifyContent="center">
              <Span
                text={`Competência ${
                  competenciaAtual
                    ? FORMAT.competencia(competenciaAtual)
                    : moment().subtract(1, 'month').format('MM/YYYY')
                }`}
                color={COLORS.black}
                fontSize={TYPOGRAPHY.bodySize16}
                marginLeft={SPACING.spacing50}
                marginTop={SPACING.spacing20}
              />
            </Col>
          </>
        )}
      </Row>

      <Col>
        <Input
          control={control}
          label="Pesquisa Geral"
          placeholder="Nome do fornecedor"
          formValue="searchGlobal"
          maxLength={895}
          inputIcon={<SearchIcon style={{ cursor: 'default' }} />}
          disabled={listContracts?.length === 0}
        />
      </Col>
    </Row>
  )
}
